import * as SidebarActionTypes from '../../../constants/sidebar/ActionTypes';
import { PanelTypes, ModuleTypes } from '../../../constants/sidebar/DragAndDropTypes';
import update from 'immutability-helper'

const initialState = {
    initialData : { modules: [], moduleCount : 0},
    modules: [],
    sidebarCount : 0,
    moduleCount : 0,
};

export default (state = initialState, action) => {

    switch (action.type) {
        case SidebarActionTypes.INIT_SIDEBAR:

            let moduleCount = 0;

            moduleCount += action.data.basicModules.length;
            moduleCount += action.data.userModules.length;

            for(let i = 0; i < action.data.activeModules.length; i++) {
                moduleCount += action.data.activeModules[i].length
            }

            return {
                initialData : {
                    modules: action.data.activeModules,
                    moduleCount : moduleCount
                },
                modules: action.data.activeModules,
                sidebarCount : action.data.sidebarCount,
                moduleCount : moduleCount
            };

        case SidebarActionTypes.ARRANGE_ACTIVE_MODULE:

            if(action.oldIndex === action.newIndex)
                return state;

            const idx = parseInt(action.panelName.substring(7, action.panelName.length));
            return update(state, {
                modules : {
                    [idx]: {
                        $splice: [
                            [action.oldIndex, 1],
                            [action.newIndex, 0, action.module],
                        ],
                    }
                }
            });

        case SidebarActionTypes.MOVE_IN_MODULE :
            if( (action.panelName !== PanelTypes.BASIC)
                &&
                (action.panelName !== PanelTypes.USER)) {

                const idx = parseInt(action.panelName.substring(7, action.panelName.length));
                let module = action.module;
                let newModule = Object.assign({}, module);
                let newModuleObj = Object.assign({}, newModule.module);
                newModule.module = newModuleObj;
                newModule.module.container = (idx + 1);

                let moduleCount = state.moduleCount;
                if(module.type !== ModuleTypes.NORMAL ) {
                    moduleCount++;
                    module.moduleId = moduleCount;
                }

                return update(state, {
                    modules : {
                        [idx] : {
                            $splice : [[action.index, 0, newModule]]
                        }
                    },
                    moduleCount : {$set: moduleCount},
                });

            }

            return state;

        case SidebarActionTypes.MOVE_OUT_MODULE :
            if( (action.panelName !== PanelTypes.BASIC)
            &&
                (action.panelName !== PanelTypes.USER)) {
                const idx = parseInt(action.panelName.substring(7, action.panelName.length));
                const modules = state.modules[idx];
                const moduleIndex = (modules.findIndex((item, idx) => item.moduleId === action.moduleId));

                return update(state, {
                    modules : {
                        [idx] : {
                            $splice : [[moduleIndex, 1]]
                        }
                    }
                });

            }else{
                return state;
            }
        case SidebarActionTypes.UPDATE_MODULE :

            let isExist = false;
            let panelIdx = null;
            let moduleIndex = null;
            let newModuleCount = state.moduleCount;
            for(let i = 0; i < state.modules.length ; i++) {

                moduleIndex = state.modules[i].findIndex((item, idx) => item.moduleId === action.module.moduleId);
                if(moduleIndex !== -1){
                    panelIdx = i;
                    isExist = true;
                    break;
                }
            }
            if(isExist) {
                const modules = state.modules[panelIdx];
                const module = modules[moduleIndex];
                let newModule = Object.assign({}, module);
                newModuleCount++;

                // 모듈 정보 갱신
                newModule.title = action.params.label;
                newModule.parameters = action.params;
                newModule.module.data.parameters = action.params;
                newModule.moduleId = newModuleCount;
                newModule.module.container = (panelIdx + 1);

                return update(state, {
                    modules : {
                        [panelIdx] : {
                            $splice : [[moduleIndex, 1, newModule]]
                        }
                    },
                    moduleCount : {$set: newModuleCount},
                });

            }

            return state;

        case SidebarActionTypes.REMOVE_MODULE :

            if((action.panelName !== PanelTypes.USER) && (action.panelName !== PanelTypes.BASIC)) {
                return (update(state, {
                    [action.panelName]: {
                        $splice: [
                            [action.index, 1],
                        ],
                    }
                }));
            }else{
                return state;
            }

        default:
            return state;
    }
}
